import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { BASE_URL } from "../constant";
import "./CarouselSection.css";

const CarouselSection = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Fetch images from the API
    const fetchImages = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/homepage/carousel/get-images`
        );
        const data = await response.json();
        setImages(data.map((img) => img.imageUrl)); // Update to 'imageUrl' based on your API response
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  return (
    <div>
      <Carousel className="carousel" controls={false} indicators={true} fade>
        {images.length > 0 ? (
          images.map((image, index) => (
            <Carousel.Item key={index} interval={800}>
              <div>
                <img
                  src={image}
                  alt={`Slide ${index}`}
                  className="d-block w-100"
                />
                {/*index === 1 && (
                  <Link to="/shop">
                    <button className="shop-now-button">SHOP NOW</button>
                  </Link>
                )*/}
              </div>
            </Carousel.Item>
          ))
        ) : (
          <div>Loading...</div>
        )}
      </Carousel>
    </div>
  );
};

export default CarouselSection;
